export enum TipoIndisponibilidade {
  PARCIAL = 'PARCIAL',
  TOTAL = 'TOTAL'
}
